import { getReportIdKey } from './chunk-KW23MZFW.mjs';
import { reportRowFactory } from './chunk-JNTY2XST.mjs';
import { __export, __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';
import { createSelector } from 'reselect';

// src/state/selectors/reportsSelectors.ts
var reportsSelectors_exports = {};
__export(reportsSelectors_exports, {
  selectCreditBalancesReportById: () => selectCreditBalancesReportById,
  selectCreditBalancesReports: () => selectCreditBalancesReports,
  selectCreditBalancesReportsArray: () => selectCreditBalancesReportsArray,
  selectCreditCardBatchReportById: () => selectCreditCardBatchReportById,
  selectCreditCardBatchReports: () => selectCreditCardBatchReports,
  selectCreditCardBatchReportsArray: () => selectCreditCardBatchReportsArray,
  selectCurrentReports: () => selectCurrentReports,
  selectCustomReportById: () => selectCustomReportById,
  selectCustomReports: () => selectCustomReports,
  selectCustomReportsArray: () => selectCustomReportsArray,
  selectEmployeeSalesAndTipsReportById: () => selectEmployeeSalesAndTipsReportById,
  selectEmployeeSalesAndTipsReports: () => selectEmployeeSalesAndTipsReports,
  selectEmployeeSalesAndTipsReportsArray: () => selectEmployeeSalesAndTipsReportsArray,
  selectEndOfShiftReportById: () => selectEndOfShiftReportById,
  selectEndOfShiftReports: () => selectEndOfShiftReports,
  selectEndOfShiftReportsArray: () => selectEndOfShiftReportsArray,
  selectFavoriteReportsArray: () => selectFavoriteReportsArray,
  selectInventoryOnHandReportById: () => selectInventoryOnHandReportById,
  selectInventoryOnHandReports: () => selectInventoryOnHandReports,
  selectInventoryOnHandReportsArray: () => selectInventoryOnHandReportsArray,
  selectItemComboSalesReportById: () => selectItemComboSalesReportById,
  selectItemComboSalesReports: () => selectItemComboSalesReports,
  selectItemComboSalesReportsArray: () => selectItemComboSalesReportsArray,
  selectReportChangeData: () => selectReportChangeData,
  selectReportOriginalData: () => selectReportOriginalData,
  selectReports: () => selectReports,
  selectSalesOverviewReportById: () => selectSalesOverviewReportById,
  selectSalesOverviewReports: () => selectSalesOverviewReports,
  selectSalesOverviewReportsArray: () => selectSalesOverviewReportsArray,
  selectVoidReasonsReportById: () => selectVoidReasonsReportById,
  selectVoidReasonsReports: () => selectVoidReasonsReports,
  selectVoidReasonsReportsArray: () => selectVoidReasonsReportsArray
});
var selectReports = (state) => state.reports;
var selectItemComboSalesReports = (state) => selectReports(state).selectedMode.currentReports.itemComboSalesReports;
var selectCustomReports = (state) => selectReports(state).selectedMode.currentReports.customReports;
var selectSalesOverviewReports = (state) => selectReports(state).selectedMode.currentReports.salesOverviewReports;
var selectEndOfShiftReports = (state) => selectReports(state).selectedMode.currentReports.endOfShiftReports;
var selectCreditCardBatchReports = (state) => selectReports(state).selectedMode.currentReports.creditCardBatchReports;
var selectEmployeeSalesAndTipsReports = (state) => selectReports(state).selectedMode.currentReports.employeeSalesAndTipsReports;
var selectVoidReasonsReports = (state) => selectReports(state).selectedMode.currentReports.voidReasonsReports;
var selectInventoryOnHandReports = (state) => selectReports(state).selectedMode.currentReports.inventoryOnHandReports;
var selectCreditBalancesReports = (state) => selectReports(state).selectedMode.currentReports.creditBalancesReports;
var selectCurrentReports = (state) => selectReports(state).selectedMode.currentReports;
var selectReportChangeData = (state) => selectReports(state).changeData.data;
var selectReportOriginalData = (state) => selectReports(state).changeData.originalData;
var reportMapToRowFactory = (reportMap, bucket) => Object.values(reportMap).map((report) => __spreadProps(__spreadValues({}, reportRowFactory(report)), {
  bucket,
  bucketId: report[getReportIdKey(bucket)]
}));
var selectCustomReportsArray = createSelector(
  selectCustomReports,
  (reports) => reportMapToRowFactory(reports, "customReports")
);
var selectItemComboSalesReportsArray = createSelector(
  selectItemComboSalesReports,
  (reports) => reportMapToRowFactory(
    reports,
    "itemComboSalesReports"
  )
);
var selectSalesOverviewReportsArray = createSelector(
  selectSalesOverviewReports,
  (reports) => reportMapToRowFactory(
    reports,
    "salesOverviewReports"
  )
);
var selectEndOfShiftReportsArray = createSelector(
  selectEndOfShiftReports,
  (reports) => reportMapToRowFactory(reports, "endOfShiftReports")
);
var selectCreditCardBatchReportsArray = createSelector(
  selectCreditCardBatchReports,
  (reports) => reportMapToRowFactory(
    reports,
    "creditCardBatchReports"
  )
);
var selectEmployeeSalesAndTipsReportsArray = createSelector(
  selectEmployeeSalesAndTipsReports,
  (reports) => reportMapToRowFactory(
    reports,
    "employeeSalesAndTipsReports"
  )
);
var selectVoidReasonsReportsArray = createSelector(
  selectVoidReasonsReports,
  (reports) => reportMapToRowFactory(reports, "voidReasonsReports")
);
var selectInventoryOnHandReportsArray = createSelector(
  selectInventoryOnHandReports,
  (reports) => reportMapToRowFactory(
    reports,
    "inventoryOnHandReports"
  )
);
var selectCreditBalancesReportsArray = createSelector(
  selectCreditBalancesReports,
  (reports) => reportMapToRowFactory(
    reports,
    "creditBalancesReports"
  )
);
var selectFavoriteReportsArray = createSelector(
  selectCurrentReports,
  (allReports) => {
    const arrayOfReports = [];
    Object.entries(allReports).forEach(
      ([bucket, reports]) => {
        arrayOfReports.push(
          ...reportMapToRowFactory(
            reports,
            bucket
          )
        );
      }
    );
    return arrayOfReports.filter((report) => report.isFavorited);
  }
);
var selectCustomReportById = createSelector(
  selectCustomReports,
  (_, id) => id,
  (customReports, id) => customReports[id]
);
var selectItemComboSalesReportById = createSelector(
  selectItemComboSalesReports,
  (_, id) => id,
  (itemComboSalesReports, id) => itemComboSalesReports[id]
);
var selectSalesOverviewReportById = createSelector(
  selectSalesOverviewReports,
  (_, id) => id,
  (salesOverviewReports, id) => salesOverviewReports[id]
);
var selectEndOfShiftReportById = createSelector(
  selectEndOfShiftReports,
  (_, id) => id,
  (endOfShiftReports, id) => endOfShiftReports[id]
);
var selectCreditCardBatchReportById = createSelector(
  selectCreditCardBatchReports,
  (_, id) => id,
  (creditCardBatchReports, id) => creditCardBatchReports[id]
);
var selectEmployeeSalesAndTipsReportById = createSelector(
  selectEmployeeSalesAndTipsReports,
  (_, id) => id,
  (employeeSalesAndTipsReports, id) => employeeSalesAndTipsReports[id]
);
var selectVoidReasonsReportById = createSelector(
  selectVoidReasonsReports,
  (_, id) => id,
  (voidReasonsReports, id) => voidReasonsReports[id]
);
var selectInventoryOnHandReportById = createSelector(
  selectInventoryOnHandReports,
  (_, id) => id,
  (inventoryOnHandReports, id) => inventoryOnHandReports[id]
);
var selectCreditBalancesReportById = createSelector(
  selectCreditBalancesReports,
  (_, id) => id,
  (creditBalancesReports, id) => creditBalancesReports[id]
);

export { reportsSelectors_exports, selectCreditBalancesReportById, selectCreditBalancesReports, selectCreditBalancesReportsArray, selectCreditCardBatchReportById, selectCreditCardBatchReports, selectCreditCardBatchReportsArray, selectCurrentReports, selectCustomReportById, selectCustomReports, selectCustomReportsArray, selectEmployeeSalesAndTipsReportById, selectEmployeeSalesAndTipsReports, selectEmployeeSalesAndTipsReportsArray, selectEndOfShiftReportById, selectEndOfShiftReports, selectEndOfShiftReportsArray, selectFavoriteReportsArray, selectInventoryOnHandReportById, selectInventoryOnHandReports, selectInventoryOnHandReportsArray, selectItemComboSalesReportById, selectItemComboSalesReports, selectItemComboSalesReportsArray, selectReportChangeData, selectReportOriginalData, selectReports, selectSalesOverviewReportById, selectSalesOverviewReports, selectSalesOverviewReportsArray, selectVoidReasonsReportById, selectVoidReasonsReports, selectVoidReasonsReportsArray };
